import get from 'lodash/get';
import cuid from 'cuid';
import lodashGet from "lodash/get";

import * as Constants from '../constants';
import { sendToGTM } from '../utils/gtmHelper';
const initialState = {
  customerDetails: {},
  location: {},
  selectedPincode: '',
  loading: false,
  surveyInitiated: false,
  action: {},
  deliveredMedicines: {},
  deliveredOrders: {},
  cityAttributes: {},
  customerLead: '',
  salesforceLead: '',
  sessionId: null,
  omsEnabled: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.SET_CUSTOMER_LEAD:
      return Object.assign({}, state, {
        customerLead: action.data,
      });
    case Constants.SET_SF_LEAD:
      return Object.assign({}, state, {
        salesforceLead: action.data,
      });
    case Constants.CLOSE_LEAD_START:
      return Object.assign({}, state, { loading: true, action });
    case Constants.CLOSE_LEAD_SUCCESS:
      return Object.assign({}, state, { loading: false, action });
    case Constants.CLOSE_LEAD_FAILURE:
      return Object.assign({}, state, { loading: false, action });
    case Constants.CUSTOMER_SEARCH_START:
      return Object.assign({}, state, {
        customerDetails: state.customerDetails,
        location: state.location,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: state.selectedPincode,
        action,
        sessionId: null,
        loading: true
      });
    case Constants.CUSTOMER_SEARCH_SUCCESS:
      const newSessionID = cuid();
      const customerData = action.data.data.profile;
      sendToGTM({
        eventLabel: Constants.CUSTOMER_SEARCH_EVENT,
        source: Constants.RECOMMENDATION_SOURCE,
        eventDetails: {
          source: Constants.RECOMMENDATION_SOURCE,
          item_type: Constants.ITEM_TYPE_OTC,
          session_id: newSessionID,
          customer_name: customerData.name,
          customer_id: customerData.id,
          customer_email: customerData.email,
          mobile_number: customerData.mobileNumber,
        }
      });
      return Object.assign({}, state, {
        customerDetails: action.data,
        location: state.location,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: state.selectedPincode,
        action,
        surveyInitiated: false,
        sessionId: newSessionID,
        omsEnabled: !!lodashGet(action.data.data, 'profile.isOMSOnboarded'),
        loading: false
      });
    case Constants.CUSTOMER_SEARCH_FAILURE:
      return Object.assign({}, state, {
        customerDetails: action.data,
        location: state.location,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: state.selectedPincode,
        action,
        loading: false
      });

    case Constants.PINCODE_DELIVERABLE_START:
      return Object.assign({}, state, {
        customerDetails: state.customerDetails,
        location: state.location,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: state.selectedPincode,
        action,
        loading: true
      });
    case Constants.PINCODE_DELIVERABLE_SUCCESS:
      return Object.assign({}, state, {
        customerDetails: state.customerDetails,
        location: action.data,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: state.selectedPincode,
        action,
        loading: false
      });
    case Constants.PINCODE_DELIVERABLE_FAILURE:
      return Object.assign({}, state, {
        customerDetails: state.customerDetails,
        location: action.data,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: state.selectedPincode,
        action,
        loading: false
      });
    case Constants.SET_CUSTOMER_PINCODE:
      return Object.assign({}, state, {
        customerDetails: state.customerDetails,
        location: state.location,
        deliveredOrders: state.deliveredOrders,
        deliveredMedicines: state.deliveredMedicines,
        selectedPincode: action.data,
        action,
        loading: true
      });
    case Constants.FETCH_DIAGNOSTICS_AVAILABILITY_SUCCESS:
      return Object.assign({}, state, {
        location: {
          data: {
            cityId: get(action.data, 'data.cityAttributes.id', ''),
            cityName: get(action.data, 'data.cityAttributes.name', ''),
          },
        },
        cityAttributes: get(action.data, 'data.cityAttributes', {}),
        selectedPincode: get(action.data, 'data.pincode', {}),
        loading: false,
      });
    case Constants.SELECT_ADDRESS_SUCCESS:
      const { cityId, cityName, pincode: selectedPincode } = action.data;
      return {
        ...state,
        location: {
          data: {
            cityId: cityId || get(state, 'location.data.cityId', ''),
            cityName: cityName || get(state, 'location.data.cityName', ''),
          }
        },
        selectedPincode: selectedPincode || state.selectedPincode,
      };
    case Constants.CUSTOMER_SURVEY_INITIATED:
      return { ...state, surveyInitiated: true };

    default:
      return { ...state };
  }
}
